/* eslint-disable no-useless-computed-key */
import Vuetify from '@/plugins/vuetify';

Vuetify.framework.lang.current = (localStorage.getItem('idioma')) ? localStorage.getItem('idioma') : 'pt';

export default {
  pendentes: [],
  colunas: [
    {
      value: 'referenciaCliente',
      text: 'referenciaCliente',
      filterable: true,
      filterComponent: 'TextFilter',
      filterParams: {
        field: 'referenciaCliente',
      },
      isDataTable: true,
      width: 180,
    },
    {
      value: 'referenciaTrust',
      text: 'referenciaTrust',
      filterable: true,
      filterComponent: 'TextFilter',
      filterParams: {
        field: 'referenciaTrust',
      },
      isDataTable: true,
      width: 180,
    },
    {
      value: 'modalidadeProcesso',
      text: 'modalidade',
      filterable: true,
      isDataTable: true,
      filterComponent: 'SetFilter',
      filterParams: {
        filterSet: [
          'AEREA',
          'MARITIMA',
          'RODOVIARIA',
          'N/I',
        ],
        field: 'modalidadeProcesso',
      },
      width: 180,
    },
    {
      value: 'nomePessoa',
      text: 'cliente',
      filterable: true,
      filterComponent: 'TextFilter',
      filterParams: {
        field: 'nomePessoa',
      },
      isDataTable: true,
      width: 240,
    },
    {
      value: 'responsavel',
      text: 'responsavel',
      filterable: true,
      filterComponent: 'TextFilter',
      filterParams: {
        field: 'responsavel',
      },
      isDataTable: true,
      width: 180,
    },
    {
      value: 'dataAbertura',
      text: 'dataAbertura',
      filterable: true,
      filterComponent: 'DateFilter',
      filterParams: {
        field: 'dataAbertura',
      },
      isDataTable: true,
      width: 180,
    },
    {
      value: 'conhecimentoGerado',
      text: 'conhecimentoEmbarque',
      filterable: true,
      filterComponent: 'TextFilter',
      filterParams: {
        field: 'conhecimentoGerado',
      },
      isDataTable: true,
      width: 180,
    },
    {
      value: 'etd',
      text: 'etd',
      filterable: true,
      filterComponent: 'DateFilter',
      filterParams: {
        field: 'etd',
      },
      isDataTable: true,
      width: 180,
    },
    {
      value: 'dataEmbarque',
      text: 'dataEmbarque',
      filterable: true,
      filterComponent: 'DateFilter',
      filterParams: {
        field: 'dataEmbarque',
      },
      isDataTable: true,
      width: 180,
      class: 'backgroundRoxo',
      cellClass: 'backgroundRoxo',
    },
    {
      value: 'eta',
      text: 'eta',
      filterable: true,
      filterComponent: 'DateFilter',
      filterParams: {
        field: 'eta',
      },
      isDataTable: true,
      width: 180,
      class: 'backgroundRoxo',
      cellClass: 'backgroundRoxo',
    },
    {
      value: 'dataChegada',
      text: 'dataChegada',
      filterable: true,
      filterComponent: 'DateFilter',
      filterParams: {
        field: 'dataChegada',
      },
      isDataTable: true,
      width: 180,
    },
    {
      value: 'dataPresencaCarga',
      text: 'dataPresencaCarga',
      filterable: true,
      filterComponent: 'DateFilter',
      filterParams: {
        field: 'dataPresencaCarga',
      },
      isDataTable: true,
      width: 180,
      class: 'backgroundRoxo',
      cellClass: 'backgroundRoxo',
    },
    {
      value: 'dataCarregamento',
      text: 'carregamento',
      filterable: true,
      filterComponent: 'DateFilter',
      filterParams: {
        field: 'dataCarregamento',
      },
      isDataTable: true,
      width: 180,
    },
    {
      value: 'possuiInvoice',
      text: 'numeroInvoice',
      filterable: true,
      filterComponent: 'TextFilter',
      filterParams: {
        field: 'possuiInvoice',
      },
      isDataTable: true,
      width: 180,
    },
    {
      value: 'numeroConhecimento',
      text: 'numeroConhecimentoEmbarque',
      filterable: true,
      filterComponent: 'TextFilter',
      filterParams: {
        field: 'numeroConhecimento',
      },
      isDataTable: true,
      width: 180,
      class: 'backgroundRoxo',
      cellClass: 'backgroundRoxo',
    },
    {
      value: 'possuiContainer',
      text: 'container',
      filterable: true,
      filterComponent: 'TextFilter',
      filterParams: {
        field: 'possuiContainer',
      },
      isDataTable: true,
      width: 180,
      class: 'backgroundRoxo',
      cellClass: 'backgroundRoxo',
    },
  ],
  filtros: {
    termo: '',
    page: 1,
    perPage: 20,
    visibilidade: 'todos',
    referenciaCliente: '',
    referenciaTrust: '',
    modalidadeProcesso: '',
    nomePessoa: '',
    responsavel: '',
    dataAbertura: '',
    dataAberturaCondicao: '',
    conhecimentoGerado: '',
    etd: '',
    etdCondicao: '',
    dataEmbarque: '',
    dataEmbarqueCondicao: '',
    eta: '',
    etaCondicao: '',
    dataChegada: '',
    dataChegadaCondicao: '',
    dataPresencaCarga: '',
    dataPresencaCargaCondicao: '',
    dataCarregamento: '',
    dataCarregamentoCondicao: '',
    possuiInvoice: '',
    numeroConhecimento: '',
    possuiContainer: '',
  },
};
